import React from "react";

function ResumeButton() {
  return (
    <div style={{ marginTop: "2rem", textAlign: "center" }}>
      <a
        href="https://jaimeosvaldo.com/CV/JaimeORiveraCV-2025v06.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="resume-button"
      >
        Resumé
      </a>
    </div>
  );
}

export default ResumeButton;
